import _ from 'underscore';
import { processSharedFields } from './shared-field-processor';
import { processFilters } from './filter-processor';
import { processColumns } from './column-processor';
import { getAggregationRestrictions } from './columns/get-aggregation-restrictions';
import { preprocessReportSchemaForTimeColumns } from './polyFillReportSchema';

export function processSchema(
  entitySchema, sharedSchema,
  elevatedColumns, pilotRestrictionSets, pilotDefaultSets,
  columnNames, helpLinkIds = {}, timeRangeOverride, missingMandatoryColumnError, restrictedFilterColumnsSets, displayRestrictedSets
) {
  const rawSchema = entitySchema.properties;
  // pass-through fields
  const reportSchema = _.pick(rawSchema, 'ReportAggregation', 'ExclusionSets', 'ScopeFilterLevel', 'MandateColumnSet', 'Priority');
  reportSchema.SchemaName = rawSchema.SchemaName;
  reportSchema.ReportType = entitySchema.name;

  if (reportSchema.MandateColumnSet) {
    reportSchema.MissingMandatoryColumnError = missingMandatoryColumnError;
  }

  const supportedAggregations = reportSchema.ReportAggregation.enum;
  reportSchema.ReportAggregation.default = _.contains(supportedAggregations, 'Summary') ? 'Summary' : supportedAggregations[0];
  reportSchema.DataRetention =
    _.object(
      supportedAggregations,
      _.map(supportedAggregations, value => (value === 'Hourly' || value === 'HourOfDay' ? rawSchema.DataRetention.Hourly : rawSchema.DataRetention.Daily))
    );

  if (timeRangeOverride) {
    reportSchema.TimeRanges = timeRangeOverride;
  }

  // filter fields
  const filterFields = rawSchema.Filters.properties;
  const flatternedFilters = processSharedFields(filterFields, sharedSchema.filters);
  const processedFilter = processFilters(flatternedFilters, rawSchema.DimensionColumns);
  _.extend(reportSchema, {
    Filters: {
      type: rawSchema.Filters.type,
      properties: processedFilter,
      piloted: pilotRestrictionSets,
      restrictedFilterColumns: restrictedFilterColumnsSets,
    },
  });

  // column chooser fields
  const validCategories = ['TimeColumns', 'DimensionColumns', 'MetricColumns'];
  const columnGroups = _.pick(rawSchema, (node, key) =>
    _.contains(validCategories, key) && !_.isEmpty(node));
  const {
    default: defaultColumns,
    linechartDefault,
    barchartDefault,
    mandatory: mandatoryColumns,
  } = elevatedColumns;
  // For those have mandatory columns more than 4(so far account report and destinationUrl report),
  // we don't show chart, because they have more than one row
  const RenderTypes = ['Table']
    .concat(linechartDefault && mandatoryColumns.length < 4 ? ['Linechart'] : [])
    .concat(barchartDefault && mandatoryColumns.length < 4 ? ['Barchart'] : []);

  let allMandatoryColumnsMap = {};

  if (rawSchema.SchemaName !== 'UIUnifiedPreview') {
    const allMondatoryColumns = _.union(rawSchema.RequiredColumns, mandatoryColumns);
    allMandatoryColumnsMap = _.object(allMondatoryColumns, allMondatoryColumns);
  }

  const aggregationRestrictions = getAggregationRestrictions(rawSchema);

  const processedColumns =
    processColumns(
      columnGroups, allMandatoryColumnsMap, aggregationRestrictions,
      columnNames, helpLinkIds
    );
  _.extend(reportSchema, {
    RenderTypes,
    Columns: {
      categories: processedColumns,
      default: defaultColumns,
      linechartDefault,
      barchartDefault,
      piloted: pilotRestrictionSets,
      pilotDefault: pilotDefaultSets,
      displayRestricted: displayRestrictedSets,
    },
  });
  preprocessReportSchemaForTimeColumns(reportSchema);

  return reportSchema;
}
